import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';
import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'MuiSunrunComparisonTable' })(
  ({ brandColors, breakpoints, typography }) => ({
    table: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: typography.pxToRem(413.33),
      minHeight: typography.pxToRem(732),
      backgroundColor: brandColors.white,
      borderRadius: typography.pxToRem(24),
      padding: typography.pxToRem(40),
      marginRight: typography.pxToRem(20),
      position: 'relative',
      '&:last-child': {
        marginRight: 0,
      },
      [breakpoints.down(ScreenSize.LARGE)]: {
        width: typography.pxToRem(285.33),
        minHeight: typography.pxToRem(721),
        padding: typography.pxToRem(24),
      },
    },
    title: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      marginBottom: typography.pxToRem(16),
      fontSize: typography.pxToRem(32),
      fontWeight: 500,
      [breakpoints.down(ScreenSize.LARGE)]: {
        fontSize: typography.pxToRem(24),
      },
    },
    subtitle: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      marginBottom: typography.pxToRem(40),
      fontSize: typography.pxToRem(16),
      fontWeight: 400,
      color: brandColors.tintsNeutral10,
      [breakpoints.down(ScreenSize.LARGE)]: {
        fontSize: typography.pxToRem(14),
      },
    },
    header: {
      display: 'flex',
      flexDirection: 'column',
    },
    benefits: {
      display: 'flex',
      flexDirection: 'column',
      margin: `0 ${typography.pxToRem(12.67)}`,
      //height: typography.pxToRem(351),
      overflow: 'hidden',
      [breakpoints.down(ScreenSize.LARGE)]: {
        //height: typography.pxToRem(387),
        margin: 0,
      },
    },
    cta: {
      '& .MuiButton-button': {
        '& .MuiButton-PrimaryBluePill': {
          textDecoration: 'none',
          height: typography.pxToRem(50),
          padding: '18px 0',
          width: '100%',
          '&:hover': {
            textDecoration: 'underline',
          },
        },
      },
    },
    benefitContainer: {
      marginBottom: typography.pxToRem(24),
    },
    benefit: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      marginTop: typography.pxToRem(12.5),
    },
    benefitTitle: {
      fontSize: typography.pxToRem(16),
    },
    benefitName: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      justifyContent: 'center',
      [breakpoints.down(ScreenSize.LARGE)]: {
        fontSize: typography.pxToRem(16),
      },
    },
    benefitIcon: {
      display: 'flex',
      flexDirection: 'column',
      width: typography.pxToRem(23),
      marginRight: typography.pxToRem(18),
    },
    favorite: {
      width: typography.pxToRem(409.33),
      border: `4px solid #FCE838`,
      [breakpoints.down(ScreenSize.LARGE)]: {
        width: typography.pxToRem(281.33),
      },
    },
    favoriteTag: {
      width: typography.pxToRem(110),
      height: typography.pxToRem(31),
      borderRadius: typography.pxToRem(24),
      backgroundColor: '#FCE838',
      color: brandColors.black,
      fontSize: '1rem',
      fontWeight: 500,
      padding: typography.pxToRem(5),
      textAlign: 'center',
      position: 'absolute',
      left: '38%',
      top: '-1rem',
      [breakpoints.down(ScreenSize.LARGE)]: {
        left: '32%',
      },
    },
  })
);

export default useStyles;
